import { varsnap } from './core.js';

export default varsnap;
